export const i18n = {
  defaultLocale: 'de-DE',
  defaultLanguage: 'de',
  defaultCountry: 'DE',
  locales: ['de-DE', 'en-DE', 'en-CH', 'de-CH', 'en-AT', 'de-AT'],
  languages: ['en', 'de'],
  countries: ['DE', 'CH', 'AT'],
} as const;

export type Locale = (typeof i18n)['locales'][number];
export type Languages = (typeof i18n)['languages'][number];
export type countries = (typeof i18n)['countries'][number];
